<template>
	<div class="started">
		<button class="btn btn-lg btn-success text-uppercase" id="started" @click="$emit('startGame')">
			{{ 'Start' | translate }}
		</button>
		<!-- <button @click="$router.go(-1)" class="btn btn-lg btn-pink text-uppercase">
			{{ 'back' | translate }}
		</button> -->
	</div>
</template>

<script>
export default {
	mounted() {
		document.querySelectorAll('#started')[0].focus()
	},
}
</script>

<style scoped>
.result button {
	display: block;
	width: 260px;
	margin: 10px auto;
}

.btn-pink {
	background-color: #e4467b;
	color: #fff;
	height: 50px;
	margin: 10px 0;
	width: 260px;
	cursor: pointer;
}

.btn-pink:hover {
	background-color: #e85183;
}

.started .btn {
	width: 250px;
	display: block;
}
</style>
